<template>
    <div class="codics-aonaer-info-sys-user-record-body">
        <div class="codics-aonaer-info-sys-user-record-title">积分记录</div>
        <el-table :data="recordData" border
            style="width: 100%;position: relative;float:left;margin-top: 20px !important;margin-bottom: 30px !important;">
            <el-table-column prop="remark" label="记录备注" width="180">
            </el-table-column>
            <el-table-column prop="num" label="增减数值" width="180">
            </el-table-column>
            <el-table-column prop="ctime" label="时间" width="180">
            </el-table-column>
            <el-table-column prop="ov" label="增减前">
            </el-table-column>
            <el-table-column prop="nv" label="增减后">
            </el-table-column>
            <!-- <el-table-column align="right" label="操作" min-width="150">
                <template slot-scope="scope">
                        <el-button size="mini" :type="['info', 'primary', ''][0]" slot="reference"
                            plain>{{'查询详情'}}</el-button>
                </template>
            </el-table-column> -->
        </el-table>
    </div>
</template>

<script>
import { getPointRecords } from '@/api';
export default {
    data() {
        return {
            recordData: []
        }
    },
    mounted() {
        this.getPointRecordsFuc();
    },
    methods: {
        initHimg(str) {

            return 'https://cdn.bosscaigou.com/' + str.split(',')[0];

        },
        async getPointRecordsFuc() {

            let data = await getPointRecords();

            if (data.code == 200) {

                this.recordData = data.data.reverse();

            } else {

                this.$message.error(data.message);

            }

        }
    }
}
</script>

<style>
.codics-aonaer-info-sys-user-record-body {
    height: fit-content;
    min-height: 470px;
    width: 100%;
    position: relative;
    float: left;
    background: #FFF;
    padding: 0 30px;
    box-sizing: border-box;
}

.codics-aonaer-info-sys-user-record-title {
    height: 70px;
    width: 100%;
    position: relative;
    float: left;
    box-sizing: border-box;
    font-size: 22px;
    font-weight: bold;
    color: #333;
    line-height: 90px;
}

.codics-aonaer-info-sys-user-record-title::before {
    content: '';
    height: 2px;
    width: 60px;
    position: absolute;
    margin: auto;
    left: 16px;
    bottom: 0;
    background: #ea5b18;
    border-radius: 1px;
}
</style>